<div class="modal-header flex-column align-items-start">
  <div class="d-flex justify-content-between">
    <h5 class="modal-title" id="exampleModalLabel">{{ title() | translate }}</h5>
    @if (!hideCloseIcon) {
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modalRef.close()"></button>
    }
  </div>
  @if(subtitle()) {
   <h6>{{subtitle() | translate}}</h6>
  }
</div>
<div class="modal-body">

  <ng-content></ng-content>

</div>
@if (!hideButtons()) {
  <div class="modal-footer">
    <div class="d-flex justify-content-between align-items-center gap-2 w-100">
      <div>
        @if (additionalButtonText()) {
          <app-mdb-button [text]="additionalButtonText()"
            (onClick)="additionalButtonClicked.emit($event)"
            [outlined]="additionalButtonOutlined()"
            [loading]="additionalButtonLoading()"
          [color]="additionalButtonColor()"></app-mdb-button>
        }
      </div>
      <div class="d-flex gap-2 align-items-center">
        <app-mdb-button [text]="closeText()"
          (onClick)="modalRef.close()"
        [color]="'secondary'"></app-mdb-button>
        <app-mdb-button [text]="submitText()"
          (onClick)="submitClicked.emit()"
        [loading]="loading()"></app-mdb-button>
      </div>
    </div>
  </div>
}
